import React, { Component } from "react";
import Header from "./header";
import MenuBar from "./navbar";
import { BASE_URL, getImages } from "./utility";

class NewProducts extends Component {
  constructor() {
    super();
    this.state = {
      newarrival: [],
      dpanels: [],
      fabio: [],
      floorings: [],
      indoorwpclouvers: [],
      outdoorwpclouvers: [],
      fundermax: [],
      hpl: [],
      wpcbaffleceilings: [],
      soffitpanels: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchCategory = async (stateKey, category) => {
    try {
      const response = await fetch(`${BASE_URL}filenames/${category}`);
      const imageNames = await response.json();
      this.setState({ [stateKey]: Array.isArray(imageNames) ? imageNames : [] });
    } catch (error) {
      console.error(`Failed to load ${category} images`, error);
      this.setState({ [stateKey]: [] });
    }
  };

  fetchData = async () => {
    await Promise.all([
      this.fetchCategory("newarrival", "newarrivals"),
      this.fetchCategory("dpanels", "3d_panels"),
      this.fetchCategory("fabio", "fabio"),
      this.fetchCategory("floorings", "floorings"),
      this.fetchCategory("indoorwpclouvers", "indoorwpclouvers"),
      this.fetchCategory("outdoorwpclouvers", "outdoorwpclouvers"),
      this.fetchCategory("hpl", "hpl"),
      this.fetchCategory("fundermax", "fundermax"),
      this.fetchCategory("wpcbaffleceilings", "wpcbaffleceilings"),
      this.fetchCategory("soffitpanels", "soffitpanels"),
    ]);
  };

  renderGallery(title, images) {
    return (
      <section className="new-arrivals-section">
        <h3>{title}</h3>
        {images.length > 0 ? (
          <div className="new-arrivals-grid">
            {images.map((image, index) => (
              <a
                key={`${image.src}-${index}`}
                href={image.src}
                target="_blank"
                rel="noopener noreferrer"
                className="new-arrivals-tile"
              >
                <img src={image.src} alt={`${title} ${index + 1}`} />
              </a>
            ))}
          </div>
        ) : (
          <p className="new-arrivals-empty">Loading images...</p>
        )}
      </section>
    );
  }

  render() {
    const galleries = [
      ["WPC Baffle Ceilings", getImages("wpcbaffleceilings", this.state.wpcbaffleceilings)],
      ["Soffit Panels", getImages("soffitpanels", this.state.soffitpanels)],
      ["Indoor WPC Louvers", getImages("indoorwpclouvers", this.state.indoorwpclouvers)],
      ["Outdoor WPC Louvers", getImages("outdoorwpclouvers", this.state.outdoorwpclouvers)],
      ["HPL", getImages("hpl", this.state.hpl)],
      ["Fundermax", getImages("fundermax", this.state.fundermax)],
      ["3D Panels", getImages("3d_panels", this.state.dpanels)],
      ["Floorings", getImages("floorings", this.state.floorings)],
      ["Wallpapers", getImages("fabio", this.state.fabio)],
      ["Wooden & Gym Floorings", getImages("newarrivals", this.state.newarrival)],
    ];

    return (
      <div style={{ backgroundImage: `url(${BASE_URL}download/general/bg)` }}>
        <style>{`
          .new-arrivals-page {
            width: min(1180px, calc(100% - 24px));
            margin: 0 auto;
            padding: 0 0 2rem;
          }

          .new-arrivals-title {
            color: white;
            text-align: center;
            margin: 1.5rem 0 1rem;
            font-weight: 800;
          }

          .new-arrivals-section {
            margin: 2rem 0;
          }

          .new-arrivals-section h3 {
            color: white;
            margin: 0 0 1rem;
            text-align: center;
            font-size: 1.35rem;
            font-weight: 750;
          }

          .new-arrivals-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
            gap: 12px;
          }

          .new-arrivals-tile {
            display: block;
            aspect-ratio: 4 / 3;
            overflow: hidden;
            border-radius: 10px;
            border: 1px solid rgba(255, 255, 255, 0.14);
            background: rgba(0, 0, 0, 0.35);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
          }

          .new-arrivals-tile img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition: transform 180ms ease;
          }

          .new-arrivals-tile:hover img {
            transform: scale(1.04);
          }

          .new-arrivals-empty {
            color: rgba(255, 255, 255, 0.72);
            text-align: center;
            margin: 0;
          }

          @media (max-width: 520px) {
            .new-arrivals-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
              gap: 9px;
            }
          }
        `}</style>

        <Header />
        <MenuBar />

        <main className="new-arrivals-page">
          <h2 className="new-arrivals-title">New Arrivals</h2>
          {galleries.map(([title, images]) => this.renderGallery(title, images))}
        </main>
      </div>
    );
  }
}

export default NewProducts;
